
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as FeedbackIconComponent } from "./feedback-icon.svg";

export const FeedbackIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <FeedbackIconComponent {...props} />;
};
